module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayheavysnow@3-ec1f9c9604ea56e67db391b39dad716b.png";